import Hero from "@/components/Hero";
import PublicEventsSection from "@/components/PublicEventsSection";
import AffiliateProgram from "@/components/AffiliateProgram";

const Index = () => {
  return (
    <div className="min-h-screen bg-black">
      <Hero />
      <PublicEventsSection variant="landing" limit={12} />
      <AffiliateProgram />
    </div>
  );
};

export default Index;
